import filtresApportsApi from '@/api/filtres-apports.api'

const getDefaultState = () => {
  return {
    filtresAdherent: {},
    filtresValeursPossibles: {
      numerosBonsApport: [],
      typesContratApport: [],
      numerosContratsApport: [],
      moisApport: [],
      grainesValorisees: [{}],
    },
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),

  getters: {
    filtresAdherent (state) {
      return state.filtresAdherent
    },
    filtresValeursPossibles (state) {
      return state.filtresValeursPossibles
    },
  },
  mutations: {
    SET_FILTRES_ADHERENT (state, filtresAdherent) {
      state.filtresAdherent = filtresAdherent
    },
    SET_VALEURS_FILTRES_APPORT (state, filtresApport) {
      state.filtresValeursPossibles.numerosBonsApport = filtresApport.numerosBonsApport
      state.filtresValeursPossibles.typesContratApport = filtresApport.typesContratApport
      state.filtresValeursPossibles.numerosContratsApport = filtresApport.numerosContratsApport
      state.filtresValeursPossibles.moisApport = filtresApport.moisApport
      state.filtresValeursPossibles.grainesValorisees = filtresApport.grainesValorisees
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    initFiltresApports ({ commit, rootGetters }, params) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return filtresApportsApi.getValeursFiltresApport(username, params.anneeRecolte, params.codeGraineRs3)
        .then(result => {
          const numerosBonsApportAvecTous = result.numerosBonsApport
          numerosBonsApportAvecTous.unshift('Tous')

          const typesContratApportAvecTous = result.typesContratApport
          typesContratApportAvecTous.unshift('Tous')

          const numerosContratsApportAvecTous = result.numerosContratsApport
          numerosContratsApportAvecTous.unshift('Tous')

          const moisApportAvecTous = Object.values(result.moisApport)
          moisApportAvecTous.unshift({ 0: 'Tous' })

          const grainesValoriseesAvecTous = result.grainesValorisees
          grainesValoriseesAvecTous.unshift({ codeGraineValorisee: 'Tous', libelleGraineValorisee: 'Tous' })

          const resultComplet = {
            numerosBonsApport: numerosBonsApportAvecTous,
            typesContratApport: typesContratApportAvecTous,
            numerosContratsApport: numerosContratsApportAvecTous,
            moisApport: moisApportAvecTous,
            grainesValorisees: grainesValoriseesAvecTous
          }
          commit('SET_VALEURS_FILTRES_APPORT', resultComplet)
          return resultComplet
        })
    },
    setFiltres ({ commit }, filtresAdherent) {
      return commit('SET_FILTRES_ADHERENT', filtresAdherent)
    },
    reset ({ commit }) {
      commit('RESET')
    }
  }
}

export default module
